import { z } from "zod";
import { BaseOutputSchema } from "./BaseOutput";
import { TaxonomyDtoSchema } from "./TaxonomyDto";
import { RequestFileDtoSchema } from "./RequestFileDto";

export const ChangeFileTaxonomyOutputSchema = BaseOutputSchema.extend({
    taxonomy: TaxonomyDtoSchema.nullish(),
    file: RequestFileDtoSchema.nullish(),
});

export type ChangeFileTaxonomyOutput = z.infer<typeof ChangeFileTaxonomyOutputSchema>;